import { toast } from './toast';

interface ApiErrorData {
  error: string;
  requiresUpgrade?: boolean;
}

/**
 * Handles API errors with user-friendly messages and upgrade prompts
 * @param errorData - The error data from the API response
 * @param onUpgrade - Optional callback for upgrade action
 */
export function handleApiError(errorData: ApiErrorData, onUpgrade?: () => void): void {
  if (errorData.requiresUpgrade) {
    // Show error toast with upgrade action
    toast.error('Oppgradering nødvendig', errorData.error);
    // If upgrade callback provided, trigger it after a short delay
    if (onUpgrade && typeof onUpgrade === 'function') {
      setTimeout(() => onUpgrade(), 1500);
    }
  } else {
    // Show regular error toast
    toast.error('Noe gikk galt', errorData.error);
  }
}
